export default __webpack_public_path__ + "static/media/1516 knife block B top.a6332d5b.png";